
const initialState = {
    workorderDateandTime: "",
    targetDate:"",
    contactNo: "",
    assetNo: "",
    oldAssetNo: "",
    description: "",
    underwarrenty: "",
    location: "",
    workgroupDescription: "",
    locationCode:"",
    locationDesc:"",
    deptDesc:"",
    requestDetails: "",
    category: "",
    type: "",
    priority: [],
    cancelledBy: "",
    reasonforCancellation: "",
    ppmscheduletrackId: "",
    partReplacementRows: [],
    completionInfo: {
      respondedBy: "",
      designation: "",
      respondedDateandTime: "",
      duration: "",
      downTimeHours: "",
      completionBy: "",
      startDateandTime: "",
      endDateandTime: "",
      actionTaken: "",
      signatureFiles: [],
      costInfo: {
        editmode: false,
        breakDownCost: "",
        poNumber: "",
        ppmCostByPurchaseOrder: "",
        poNumberByPurchaseOrder: "",
        ppmCostByContract: "",
        contractReferenceNumber: "",
        totalSparePartCost: "",
        totalWorkorderCost: "",
      }
    },
    assessments: {
      respondedBy: "",
      designation: "",
      taskCode: "",
      taskDescription: "",
      repairType: "",
      partsRequired: "",
      assetTakenLocation: "",
      respondedFinding: "",
      vendor: "",
      outsourceRespondRemarks: "",
      repairTracker: []
    },
    vendorField: false,
    editmode: false,
    formSubmitStatus: true,
  };
  
  
  
  const routineInspecBasicdetailsReducer = (state = initialState, action) => {
  
    switch (action.type) {
      case 'UPDATE_BASIC_DETAILS_ROUTINE_INSPECTION':
        
        return {
          ...state,
          ...action.payload,
        };
      case 'CLEAR_BASIC_DETAILS_ROUTINE_INSPECTION':
        return initialState;
  
  
      case 'CREATE_ASSESMENTS_ROUTINE_INSPECTION':
        return {
          ...state,
          assessments: {
            ...state?.assessments,
            ...action?.payload,
            repairTracker: state?.assessments?.repairTracker
          }
        };
  
        case 'ADD_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION':
      return {
        ...state,
        assessments: {
          ...state.assessments,
          repairTracker: [
            ...state.assessments.repairTracker,
            action.payload,
          ],
        },
      };
      
      case 'UPDATE_REPAIR_TRACKER_DETAILS_ROUTINE_INSPECTION':

      if (action.payload?.dummy_id) {
        return {
          ...state,
          repairTracker: state?.assessments?.repairTracker?.map((data) =>
            data?.dummy_id === action?.payload?.dummy_id
              ? { ...data, ...action.payload }
              : data
          ),
        };
      } else if (action.payload?.id) {
        return {
          ...state,
          repairTracker: state?.assessments?.repairTracker?.map((data) =>
            data?.id === action?.payload?.id
              ? { ...data, ...action.payload }
              : data
          ),
        };
      } else {
        return;
      }

    case 'DELETE_REPAIR_TRACKER_ROUTINE_INSPECTION':
      if (action?.payload?.dummy_id) {
        return {
          ...state,
          assessments: {
            ...state.assessments,
            repairTracker: state.assessments.repairTracker?.filter(
              (item) => item?.dummy_id !== action?.payload?.dummy_id
            ),
          },
        };
      } else if (action?.payload?.id) {
        return {
          ...state,
          assessments: {
            ...state.assessments,
            repairTracker: state.assessments.repairTracker?.filter(
              (item) => item?.id !== action?.payload?.id
            ),
          },
        };
      } else {
        return state;
      }


    case "CLEAR_REPAIRTRACKER_ROUTINE_INSPECTION":
      return {
        ...state,
        assessments: {
          ...state.assessments,
          repairTracker: [],
        },
      }

      case 'PART_REPLACEMENT_ROUTINE_INSPECTION':
        return {
          ...state,
          partReplacementRows: [
            ...state.partReplacementRows,
            action.payload,
          ],
        };
  
      case 'UPDATE_PART_REPLACEMENT_ROUTINE_INSPECTION':
        if (action.payload?.dummy_id) {
          return {
            ...state,
            partReplacementRows: state.partReplacementRows.map((item) =>
              item?.dummy_id === action?.payload?.dummy_id
                ? { ...item, ...action.payload }
                : item
            ),
          };
        } else if (action.payload?.id) {
          return {
            ...state,
            partReplacementRows: state.partReplacementRows.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, ...action.payload }
                : item
            ),
          };
        } else {
          return;
        }
  
      case 'DELETE_PART_REPLACEMENT_ROUTINE_INSPECTION':
        if (action?.payload?.dummy_id) {
          return {
            ...state,
            partReplacementRows: state?.partReplacementRows?.filter(
              (item) => item?.dummy_id !== action?.payload?.dummy_id
            ),
          };
        } else if (action?.payload?.id) {
          return {
            ...state,
            partReplacementRows: state?.partReplacementRows?.filter(
              (item) => item?.id !== action?.payload?.id
            ),
          };
        } else {
          return;
        };
  
  
      case 'CLEAR_PART_REPLACEMENT_ROUTINE_INSPECTION':
        return {
          ...state,
          partReplacementRows: []
        };
  
      case 'CREATE_COMPLETIONINFO_ROUTINE_INSPECTION':
        return {
          ...state,
          completionInfo: {
            ...state.completionInfo,
            ...action.payload,
            costInfo: { ...state.completionInfo.costInfo }, // Ensure costInfo remains intact
          }
        };
  
  
      case 'CREATE_COST_INFO_ROUTINE_INSPECTION':
        return {
          ...state,
          completionInfo: {
            ...state.completionInfo,
            costInfo: {
              ...state.completionInfo.costInfo,
              ...action.payload,
            }
          }
        };
  
      case 'SET_VENDORFIELD_ROUTINE_INSPECTION':
        console.log("SET_VENDORFIELD_ROUTINE_INSPECTION", action.payload);
        
        return {
          ...state,
          vendorField: action.payload
        }
  
  
      case 'CHECK_FORMSUBMITTED_ROUTINE_INSPECTION':
        return {
          ...state,
          formSubmitStatus: action?.payload
        }
  
      default:
        return state;
    }
  };
  
  export default routineInspecBasicdetailsReducer;